import React from 'react';
import { useParams } from 'react-router-dom';

export default function ChatContent() {
  const { chatId } = useParams();
  return (
        <div>Chat id: {chatId || 0}</div>
  );
}